/* Lavender Farm Simulator — behavior bug fixes found in a level-100 sweep of every tab.
   Loads its own stylesheet (gllf-sim-bugfix.css) from the same theme assets folder.
   Never edits the save; only reads the game's markup and presses the game's own buttons. */
(function () {
  'use strict';
  if (window.__gllfSimBugfix) return;
  window.__gllfSimBugfix = true;
  (function () {
    var src = (document.currentScript && document.currentScript.src) || '';
    if (!src || document.getElementById('gllf-sim-bugfix-css') || document.querySelector('link[href*="gllf-sim-bugfix.css"]')) return;
    var l = document.createElement('link'); l.id = 'gllf-sim-bugfix-css'; l.rel = 'stylesheet';
    l.href = src.replace(/gllf-sim-bugfix\.js/, 'gllf-sim-bugfix.css');
    document.head.appendChild(l);
  })();

  function root() { return document.getElementById('lfg-simulator-root'); }

  /* ---------- Tab highlight out of step with the page ----------
     When the game refuses a move (e.g. "Flower Farm needs its corresponding Farm Map placement") it keeps
     showing the Farm Map and explains why, but the tab row still highlighted Flower Farm. Pressing the
     highlighted tab then did nothing. After a refused move, the tab of the area actually on screen is
     re-selected (through the game's own tab button), so the highlight always matches the page. */
  var pending = null;
  function coachText() {
    var c = document.getElementById('lfg-action-coach-lfg-simulator-root');
    return c && !c.hidden && c.getClientRects().length ? c.textContent : '';
  }
  document.addEventListener('lfg:route-enter', function (e) {
    var d = e.detail || {}; if (!d.route) return;
    clearTimeout(pending);
    var want = d.route, t0 = Date.now(), c0 = coachText();
    (function check() {
      var r = root(); if (!r) return;
      var target = r.querySelector('#lfg-view-' + want);
      if (target && !target.hidden && target.offsetParent) return;        /* it opened: nothing to fix */
      var active = r.querySelector('section.lfg-view.active');
      var showing = active && !active.hidden && active.offsetParent && active.id.replace(/^lfg-view-/, '');
      var tabOn = r.querySelector('[data-tab="' + want + '"][aria-selected="true"]');
      var ct = coachText(), tab = r.querySelector('[data-tab="' + want + '"]');
      var label = tab ? tab.textContent.replace(/[^A-Za-z ]/g, '').trim() : want;
      var refused = (ct !== c0 && /didn.t run/i.test(ct)) || (label && ct.indexOf(label + ' didn') >= 0);
      if (showing && showing !== want && tabOn && refused) {
        var real = r.querySelector('[data-tab="' + showing + '"]');
        if (real && !real.disabled && real.getAttribute('aria-disabled') !== 'true') {
          window.__gllfTabResync = Date.now();
          real.click();
        }
        return;
      }
      if (Date.now() - t0 < 6000) pending = setTimeout(check, 250);
    })();
  }, true);

  /* ---------- Unreadable text (mostly at night) ----------
     A sweep found text drawn almost the same color as its card: light text on light cards at night
     (Travel directory, Farm Circuit levels, Supply Yard links, Operations "ready" chips) and dark text on
     dark cards (map soil readouts, Shop prices, Mastery tags). Contrast ratios were 1.0–1.9 (readable
     needs 4.5). Any text in the open area that is below 3:1 against its own solid background is switched
     to the dark ink or the light ink, whichever reads better. Re-checked when the day/night theme flips
     and when new content appears. Works in small idle-time chunks so it never slows the game. */
  var DARK = [47, 41, 54], LIGHT = [255, 250, 255];
  function rgb(c) { var m = String(c).match(/[\d.]+/g); return m ? m.map(Number) : null; }
  function lum(a) { return a.slice(0, 3).reduce(function (s, v, i) { v /= 255; v = v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); return s + v * [0.2126, 0.7152, 0.0722][i]; }, 0); }
  function ratio(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function solidBg(e) {
    for (var n = 0; e && e.nodeType === 1 && n < 25; e = e.parentElement, n++) {
      var cs = getComputedStyle(e);
      if (cs.backgroundImage && cs.backgroundImage !== 'none') return null;   /* gradient/photo: leave it */
      var c = rgb(cs.backgroundColor);
      if (c && (c.length < 4 || c[3] > 0.9)) return c;
    }
    return null;
  }
  function fixInk(e) {
    if (e.__gllfInk === theme || !e.isConnected || !e.offsetParent) return;
    e.__gllfInk = theme;
    if (e.closest('.lfg-sr-only, svg, canvas, .gllf-loadbar')) return;
    var own = '';
    for (var i = 0; i < e.childNodes.length; i++) if (e.childNodes[i].nodeType === 3) own += e.childNodes[i].textContent;
    if (!/[A-Za-z0-9]/.test(own)) return;
    if (e.hasAttribute('data-gllf-ink')) { e.style.removeProperty('color'); e.removeAttribute('data-gllf-ink'); }
    var cs = getComputedStyle(e), fg = rgb(cs.color);
    if (!fg || (fg.length > 3 && fg[3] < 0.5) || parseFloat(cs.opacity) < 0.5) return;
    var bg = solidBg(e); if (!bg) return;
    if (ratio(fg, bg) >= 3) return;
    var ink = ratio(DARK, bg) >= ratio(LIGHT, bg) ? DARK : LIGHT;
    e.style.setProperty('color', 'rgb(' + ink.join(',') + ')', 'important');
    e.setAttribute('data-gllf-ink', '');
  }
  var theme = '', queue = [], running = false;
  function enqueue(scope) {
    if (!scope) return;
    var list = scope.querySelectorAll('*');
    for (var i = list.length - 1; i >= 0; i--) queue.push(list[i]);   /* popped from the end: top of the page first */
    if (!running) { running = true; idle(work); }
  }
  /* the game keeps the main thread busy, so idle callbacks rarely come; work in 6ms slices every 60ms instead */
  function idle(fn) { setTimeout(fn, 60); }
  function work() {
    var end = performance.now() + 6;
    while (queue.length && performance.now() < end) fixInk(queue.pop());
    if (queue.length) idle(work); else running = false;
  }
  function activeArea() { var r = root(); return r && r.querySelector('section.lfg-view.active'); }
  function rescan() {
    var r = root(); if (!r) return;
    theme = r.getAttribute('data-theme') || 'day';
    queue = []; enqueue(activeArea());
  }
  var newNodes = [], nodeTimer = 0;
  (function boot(tries) {
    var r = root();
    if (!r || !r._lfg) { if (tries < 240) setTimeout(function () { boot(tries + 1); }, 250); return; }
    rescan();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].type === 'attributes') { if (ms[i].target === r && (r.getAttribute('data-theme') || 'day') !== theme) { setTimeout(rescan, 50); return; } continue; }
        var add = ms[i].addedNodes;
        for (var k = 0; k < add.length; k++) if (add[k].nodeType === 1) newNodes.push(add[k]);
      }
      if (!nodeTimer && newNodes.length) nodeTimer = setTimeout(function () {   /* throttle, not debounce */
        nodeTimer = 0;
        var area = activeArea(), batch = newNodes; newNodes = [];
        batch.forEach(function (n) { if (n.isConnected && area && area.contains(n)) { enqueue(n); queue.push(n); } });
      }, 1000);
    }).observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-theme'] });
    document.addEventListener('lfg:route-enter', function () { setTimeout(rescan, 1200); }, true);
  })(0);

  /* ---------- Greenhouse / Flower Farm / Apiary blank after placing them on the Farm Map ----------
     The game hides each work area until it is "open" (unlocked AND placed on the map). It only re-checks
     that when the map itself changes — but the unlock is granted a moment later, after the placement.
     So right after placing a greenhouse, Flower Farm or apiary the tab opened to an empty page until the
     browser was reloaded. Now, whenever the game says an area is unlocked and its structure is on the
     map, that area is shown straight away. */
  var AREAS = ['greenhouse', 'cutflower', 'apiary'];
  function revealAreas() {
    var r = root(); if (!r) return;
    var P = r._lfgProgression;
    AREAS.forEach(function (a) {
      var host = r.querySelector('#lfg-' + a);
      if (!host || host.getAttribute('data-v153-visible') !== 'false') return;
      try { if (!P || typeof P.unlocked !== 'function' || P.unlocked(a) === false) return; } catch (e) { return; }
      if (!r.querySelector('#lfg-world [data-world-cell].' + a + ':not(.locked)')) return;
      host.setAttribute('data-v153-visible', 'true');
      host.setAttribute('aria-hidden', 'false');
    });
  }
  ['lfg:route-enter', 'lfg:world-change', 'lfg:equipment-world-v153', 'lfg:render'].forEach(function (n) {
    document.addEventListener(n, function () { setTimeout(revealAreas, 300); setTimeout(revealAreas, 1500); }, true);
  });
  setInterval(revealAreas, 3000);

  /* ---------- One-minute freezes at high levels (the big one) ----------
     Every redraw of the game sorts the ~380 field cultivars, and at each comparison of two unlocked
     cultivars it asked the shop catalog linker to find the matching product — a fuzzy search that
     takes ~65ms. At level 1 almost nothing is unlocked so it was cheap; at level 100 everything is,
     so one redraw ran ~6,000 of those searches: 55–60 seconds with the page frozen, on every tab change.
     The linker's answer for a given cultivar never changes while the catalog is loaded, so it is now
     remembered: first lookup ~65ms, every repeat instant. Redraws drop from ~55s to ~50ms. The
     remembered answers are warmed up in the background a few at a time, and forgotten if the
     catalog reloads. Stock availability is still checked live every time. */
  function memoLinker() {
    var real = globalThis.LFG_CATALOG_LINKER;
    if (!real || real.__gllfMemo || typeof real.find !== 'function') return false;
    var byObj = new WeakMap(), byStr = new Map(), size = -1;
    function fresh() {
      var n = -1; try { n = typeof real.all === 'function' ? (real.all() || []).length : -1; } catch (e) {}
      if (n !== size) { size = n; byObj = new WeakMap(); byStr = new Map(); }
    }
    var w = {};
    Object.keys(real).forEach(function (k) {
      var v = real[k];
      w[k] = typeof v === 'function' ? function () { return v.apply(real, arguments); } : v;
    });
    w.find = function (x) {
      if (arguments.length !== 1) return real.find.apply(real, arguments);
      if (x && typeof x === 'object') {
        if (byObj.has(x)) return byObj.get(x);
        var r = real.find(x); byObj.set(x, r); return r;
      }
      var key = String(x);
      if (byStr.has(key)) return byStr.get(key);
      var r2 = real.find(x); byStr.set(key, r2); return r2;
    };
    w.load = function () { byObj = new WeakMap(); byStr = new Map(); return real.load.apply(real, arguments); };
    w.__gllfMemo = true;
    try { globalThis.LFG_CATALOG_LINKER = w; } catch (e) { return false; }
    setInterval(fresh, 30000);
    /* warm up in the background: one cultivar every 120ms while the tab is visible */
    var list = null, i = 0;
    (function warm() {
      if (globalThis.LFG_CATALOG_LINKER !== w) return;
      var ready = false; try { ready = real.status && real.status() === 'ready'; } catch (e) {}
      if (!list) { var r = root(); list = r && r._lfg && r._lfg.data && r._lfg.data.cultivars; }
      if (ready && list && !document.hidden) {
        var lvl = 0; try { lvl = root()._lfg.state().level || 0; } catch (e) {}
        while (i < list.length && Number(list[i].level || 1) > lvl) i++;   /* only unlocked ones are ever looked up */
        if (i < list.length) { try { w.find(list[i]); } catch (e) {} i++; }
        if (i >= list.length) return;
      }
      setTimeout(warm, 120);
    })();
    return true;
  }
  (function installMemo(tries) {
    if (globalThis.LFG_CATALOG_LINKER && globalThis.LFG_CATALOG_LINKER.__gllfMemo) {
      setTimeout(function () { installMemo(0); }, 5000);   /* keep watching in case the catalog module swaps it */
      return;
    }
    if (memoLinker() || tries > 600) { setTimeout(function () { installMemo(0); }, 5000); return; }
    setTimeout(function () { installMemo(tries + 1); }, 100);
  })(0);
})();
